// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

/**
 * Reads the experimentStartDate param from the cfind_5565_creation_focused_nav_xflow
 * experiment config without firing an exposure. Returns a parsed Date, or null if the
 * param is missing or not a valid date string.
 */
// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
export const getXflowExperimentStartDate = (): Date | null => {
	// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
	const [expConfig] = UNSAFE_noExposureExp('cfind_5565_creation_focused_nav_xflow'); // Experiment exposure is fired elsewhere
	const rawValue = expConfig.get('experimentStartDate', null);
	if (!rawValue) {
		return null;
	}
	const date = new Date(rawValue);
	return isNaN(date.getTime()) ? null : date;
};
